import Card from "components/card/Card";
import Page from "components/page/Page";
import React, { useEffect, useState } from "react";

import { StatusCode } from "api/protocols";
import { NotificationType } from "components/notificationBar/NotificationBar";
import TextEditor from "components/textEditor/textEditor";
import { isEqualWith } from "lodash";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { updateFacilityTeeSheetSettings } from "redux/actions/facility";
import { GetCartWaiver as PrintCartWaiver } from "api/rpc/2024-04/facilityAdmin/teesheet/booking";
import { showError } from "redux/actions/ui";

import { GetCartWaiver, PutCartWaiver } from "api/rpc/2024-04/facilityAdmin/facility/teesheet";
interface ICartWaiver {
  content: string;
  loaded: boolean;
}

export default function CartWaiver() {
  const [cartWaiver, setCartWaiver] = useState<ICartWaiver>({
    content: "",
    loaded: false,
  });

  const { t, i18n } = useTranslation();
  const [cartWaiverBeforeChanges, setCartWaiverBeforeChanges] = useState<ICartWaiver>(undefined);

  const { facilityStore } = useAppSelector(store => store);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (facilityStore.teeSheetSettings) {
      void loadCartWaiver();
    }
  }, [facilityStore.teeSheetSettings]);

  function loadCartWaiver() {
    setCartWaiver(prevState => {
      return {
        ...prevState,
        content: facilityStore?.teeSheetSettings?.cart_waiver_content ?? "",
        loaded: true,
      };
    });
  }

  async function saveCartWaiver() {
    await dispatch(
      updateFacilityTeeSheetSettings(
        { ...facilityStore.teeSheetSettings, cart_waiver_content: cartWaiver.content },
        true,
      ),
    );

    setCartWaiverBeforeChanges(cartWaiver);
  }

  function unsavedChangesExist() {
    if (cartWaiverBeforeChanges === undefined) {
      if (cartWaiver.loaded) {
        setCartWaiverBeforeChanges(cartWaiver);
      }
      return false;
    }

    return !isEqualWith(cartWaiverBeforeChanges, cartWaiver);
  }

  function cancelUnsavedChanges() {
    setCartWaiver(cartWaiverBeforeChanges);
  }

  function setCartWaiverContent(content: string) {
    setCartWaiver(prevState => {
      return { ...prevState, content: content };
    });
  }

  async function handlePrintBlankWaiver() {
    const printRes = await PrintCartWaiver({ test: true }, true);

    console.log(printRes);

    if (printRes.status === StatusCode.OK) {
      window.open().document.write(printRes.data);
    } else {
      dispatch(showError(t("Cart waiver has not been created")));
    }
  }

  return (
    <Page
      title={t("Cart Waiver")}
      subtitle={t("Edit details about the cart waiver")}
      narrow
      notificationBarProps={{
        isVisible: unsavedChangesExist(),
        onAction: saveCartWaiver,
        onCancel: cancelUnsavedChanges,
      }}
      multipleActionDropdownAction={{
        label: t("Options"),
        dropdownProps: {
          alignment: "right",
          options: [
            {
              type: "handler",
              label: t("Print Blank Waiver"),
              icon: "print",
              handler: handlePrintBlankWaiver,
            },
          ],
        },
      }}
    >
      <hr className="my-8" />
      {cartWaiver.loaded ? (
        <Card>
          <TextEditor markdownText={cartWaiver.content} markdownTextOnChange={setCartWaiverContent} />
        </Card>
      ) : null}
    </Page>
  );
}
